import React from 'react';
import LegalPageLayout from '../components/landing/LegalPageLayout';
import PrivacyContent from '../components/legal/PrivacyContent';

export default function PrivacidadePage() {
  return (
    <LegalPageLayout title="Política de Privacidade" lastUpdated="02 de Junho de 2025">
      <PrivacyContent />
    </LegalPageLayout>
  );
}
